import React from 'react';

import { Container, Circle } from './Subtitle.styles';

interface SubtitleProps {
	circleColor: string;
	title: string;
}

export const Subtitle = ({
	circleColor,
	title,
}: SubtitleProps): JSX.Element => {
	return (
		<Container>
			<Circle color={circleColor} />
			<p>{title}</p>
		</Container>
	);
};
